import * as DirectorySearchParamsActions from './reducers'

export const { setSearchParam } = DirectorySearchParamsActions
